import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("accessToken");
  const location = useLocation();

  if (!token) {
    // Not logged in → redirect to login with "from" state
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Logged in → show protected content
  return children;
};

export default ProtectedRoute;
